<ng-container *ngIf="!maintenanceMode" class="mat-app-background">
  <router-outlet></router-outlet>
  <app-footer *ngIf="!onCheckingNotAvailableRouters()"></app-footer>
</ng-container>
